export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5486.91e8ab1f.jpg";